export default {
    path: '/action_types',
    name: 'action_types',
    component: () => import('../components/actiontype/Layout'),
    redirect: {name: 'ActionTypeList'},
    meta: {
        breadcrumb: 'orderaction.types',
    },
    children: [
        {
            name: 'ActionTypeList',
            path: '',
            component: () => import('../views/actiontype/List'),
            meta: {
                breadcrumb: 'global.list',
            },
        },
        {
            name: 'ActionTypeCreate',
            path: 'new',
            component: () => import('../views/actiontype/Create'),
            meta: {
                breadcrumb: 'global.add',
            },
        },
        {
            name: 'ActionTypeUpdate',
            path: ':id/edit',
            component: () => import('../views/actiontype/Update'),
            meta: {
                breadcrumb: 'orderaction.type',
            },
        },
        {
            name: 'ActionTypeShow',
            path: ':id',
            component: () => import('../views/actiontype/Show'),
            meta: {
                breadcrumb: 'orderaction.type',
            },
        }
    ]
};